import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { GetPropertyList, searchProperty } from '../../request/apiRquest';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Button, Spin, Modal } from 'antd';
import FormatePrice from '../../utils/FormatePrice';
import PropertyCallingButton from '../../utils/PropertyCardCall';
import PropertyWhatsAppButton from '../../utils/PropertyCardWhatsApp';
import GetInTouch from '../../utils/getInTouch';

const SearchGrid = () => {
  const carouselSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false
  };

  const location = useLocation();
  const searchParams = new URLSearchParams(window.location.search);

  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [propertylist, setPropertyList] = useState([]);

  const [propertyFor, setPropertyFor] = useState(searchParams.get('PropertyFor') || '');
  const [selectBuildingType, setSelectedBuildingType] = useState(searchParams.get('PropertyType') || '');
  const [selectedConstructionType, setSelectedConstructionType] = useState(searchParams.get('Ready_Underconstruction') || '');
  const [selectBHK, setSelectedBHK] = useState(searchParams.get('BHKType') || '');
  const [selectMinRange, setSelectedMinRange] = useState(Number(searchParams.get('MinPrice')) || 1000);
  const [selectMaxRange, setSelectedMaxRange] = useState(Number(searchParams.get('MaxPrice')) || 1000000000);
  const [selectLocality, setSelectedLocality] = useState(searchParams.get('Locality') || '');
  const [selectStates, setSelectedStates] = useState(searchParams.get('States') || '');

  const showModal = () => setOpen(true);
  const handleCancel = () => setOpen(false);
   const [selectedProperty, setSelectedProperty] = useState(null);

  const getPropertyList = async () => {
    setLoading(true);
    try {
      let filters = {};
      if (propertyFor) filters.PropertyFor = propertyFor;
      if (selectBuildingType) filters.PropertyType = selectBuildingType;
      if (selectedConstructionType) filters.Ready_Underconstruction = selectedConstructionType;
      if (selectBHK) filters.BHKType = selectBHK;
      if (selectMinRange) filters.MinPrice = selectMinRange;
      if (selectMaxRange) filters.MaxPrice = selectMaxRange;
      if (selectLocality) filters.Locality = selectLocality;
      if (selectStates) filters.States = selectStates;

      const response = await searchProperty(filters);
      setPropertyList(response);
    } catch (error) {
      console.error("Error fetching properties:", error);
    } finally {
      setLoading(false);
    }
  };

  const setQueryParams = (key, value) => {
    searchParams.set(key, value);
    const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
    window.history.replaceState(null, '', newUrl);
  };

  const handleResetFilter = (e) => {
    e.preventDefault();
    window.history.replaceState(null, '', window.location.pathname);
    setPropertyFor('');
    setSelectedBuildingType('');
    setSelectedConstructionType('');
    setSelectedBHK('');
    setSelectedMaxRange('');
    setSelectedMinRange('');
    setSelectedLocality('');
    setSelectedStates('');
  };

  useEffect(() => {
    getPropertyList();
  }, [
    propertyFor,
    selectBuildingType,
    selectedConstructionType,
    selectBHK,
    selectMaxRange,
    selectMinRange,
    selectLocality,
    selectStates
  ]);

  return (
    <div className="search-page-wrap pd-top-100 pd-bottom-70">
      <div className="search-container">
        <div className="container">
          <div className="row">

            {/* Filters */}
            <div className="col-12 mb-4">
              <div className="filter-bar d-flex flex-wrap align-items-center justify-content-between" style={{ gap: "15px" }}>
                {/* Each filter dropdown */}
                {/* Property For */}
                <div style={{ width: "190px" }}>
                  <label className="d-block">Property For</label>
                  <select
                    className="form-control"
                    value={propertyFor}
                    onChange={(e) => {
                      setQueryParams('PropertyFor', e.target.value);
                      setPropertyFor(e.target.value);
                    }}
                  >
                    <option value="">Select</option>
                    <option value="1">Buy</option>
                    <option value="2">Rent</option>
                  </select>
                </div>

                {/* Building Type */}
                <div style={{ width: "190px" }}>
                  <label className="d-block">Building Type</label>
                  <select
                    className="form-control"
                    value={selectBuildingType}
                    onChange={(e) => {
                      setQueryParams('PropertyType', e.target.value);
                      setSelectedBuildingType(e.target.value);
                    }}
                  >
                    <option value="">Select</option>
                    <option value="1">Apartment</option>
                    <option value="2">Townhouse</option>
                    <option value="4">Villas</option>
                    <option value="5">Penthouse</option>
                    <option value="6">Studio Apartment</option>
                  </select>
                </div>

                {/* Construction Type */}
                <div>
                  <label className="d-block" style={{ width: "200px" }}>Construction Type</label>
                  <select
                    className="form-control"
                    value={selectedConstructionType}
                    onChange={(e) => {
                      setQueryParams('Ready_Underconstruction', e.target.value);
                      setSelectedConstructionType(e.target.value);
                    }}
                  >
                    <option value="">Select</option>
                    <option value="1">Ready To Move</option>
                    <option value="2">Off Plan</option>
                  </select>
                </div>

                {/* BHK Type */}
                <div style={{ width: "190px" }}>
                  <label className="d-block">BHK Type</label>
                  <select
                    className="form-control"
                    value={selectBHK}
                    onChange={(e) => {
                      setQueryParams('BHKType', e.target.value);
                      setSelectedBHK(e.target.value);
                    }}
                  >
                    <option value="">Select</option>
                    <option value="1BHK">1BHK</option>
                    <option value="2BHK">2BHK</option>
                    <option value="3BHK">3BHK</option>
                    <option value="4BHK">4BHK</option>
                  </select>
                </div>

                {/* Reset */}
                <div className="text-center">
                  <button onClick={handleResetFilter} className="btn btn-yellow mt-3">
                    <span className="left"><i className="fa fa-search" /></span> Reset Filter
                  </button>
                </div>
              </div>
            </div>

            {/* Property Results */}
            <div className="col-12">
              <div className="row mb-3">
                <div className="col-md-9 col-sm-8 d-flex align-items-center" style={{ gap: "25px" }}>
                  <h6 className="filter-title mt-3 mb-lg-0">Total-Properties: {propertylist?.length}</h6>
                </div>
              </div>

              {loading ? (
                <div className="text-center py-5">
                  <Spin size="large" tip="Loading properties..." />
                </div>
              ) : (
                <div className="row justify-content-center">
                  {propertylist?.length > 0 ? (
                    propertylist.map((item, index) => {
                      const images = item?.image || [];

                      return (
                        <div key={index} className="col-lg-4 col-md-6 mb-4">
                          <div className="single-feature">
                            <div className="thumb position-relative">
                              <Button
                                className="position-absolute"
                                style={{
                                  top: '10px',
                                  right: '10px',
                                  zIndex: 2,
                                  padding: '6px 12px',
                                  fontSize: '14px',
                                  borderRadius: '5px',
                                  width: "150px",
                                  color: "#FDA94F"
                                }}
                                onClick={showModal}
                              >
                                Enquire Now
                              </Button>
                              <img
                                src={images[0]?.src}
                                alt="Property"
                                className="img-fluid property-image"
                                style={{
                                  height: '250px',
                                  width: '100%',
                                  objectFit: 'cover',
                                }}
                              />
                            </div>

                            <div className="details">
                              <h6 className="price">{FormatePrice(item.price)} AED</h6>
                              <h6 className="title readeal-top">
                                <Link to={item.url}>{item.name}</Link>
                              </h6>
                              <h6 className="title readeal-top" style={{ fontSize: "12px" }}>
                                <i className="fa fa-home" style={{ color: "orange", fontSize: "15px" }}></i>
                                <Link to={item.url}> {item.building_type}</Link>
                              </h6>
                              <h6 className="location">
                                <i className="fa fa-map-marker" style={{ color: "orange", marginRight: "5px" }} />
                                {item.locality}
                              </h6>

                              <ul className="info-list">
                                <li><i className="fa fa-bed" /> {item.bhk_type}</li>
                                {/* <li><i className="fa fa-bath" /> {item.number_bathroom}</li> */}
                                <li><img src="/assets/img/icons/7.png" alt="area" /> {item.builtup_area} sq ft</li>
                              </ul>

                              <ul className="contact-list">
                                <li className="readeal-top">
                                  <Link className="btn btn-yellow" to={`/property-details/${item.id}`}>View Details</Link>
                                </li>
                                <li><PropertyCallingButton /></li>
                                <li><PropertyWhatsAppButton /></li>
                              </ul>
                            </div>
                          </div>

                           <Modal
        title=""
        open={open}
        onCancel={handleCancel}
        footer={null}
        maskStyle={{ backgroundColor: 'transparent' }}
        maskClosable={false}
      >
        <GetInTouch onClose={handleCancel} property={selectedProperty} />
      </Modal>
                        </div>
                      );
                    })
                  ) : (
                    <div className="col-12 text-center">
                      <p>No properties found matching your criteria.</p>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchGrid;
